module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "footer-socials"
  }, [_c('a', {
    staticClass: "social",
    attrs: {
      "href": _vm.socials.facebook ? _vm.socials.facebook : '#',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    staticClass: "social",
    attrs: {
      "href": _vm.socials.twitter ? _vm.socials.twitter : '#',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    staticClass: "social",
    attrs: {
      "href": _vm.socials.instagram ? _vm.socials.instagram : '#',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "contacts"
  }, [_c('div', {
    staticClass: "telephone"
  }, [_c('span', [_vm._v("Telephone:")]), _vm._v(" " + _vm._s(_vm.websiteContacts.phone))]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('span', [_vm._v("Email:")]), _vm._v(" " + _vm._s(_vm.websiteContacts.email))]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_vm._v(_vm._s(_vm.websiteContacts.address))])]), _vm._v(" "), _c('router-link', {
    staticClass: "find-us btn btn-danger btn-fill btn-secondary",
    attrs: {
      "to": "/contact",
      "tag": "button"
    }
  }, [_vm._v("\n          Find us on map\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("\n      " + _vm._s(_vm.year) + " Copyright © Kungfood\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "kf-footer-logo",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/KF-logo-white.png"),
      "alt": "Kungfood Logo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9999c500!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layouts/ContentFooter.vue
// module id = 562
// module chunks = 1